class HeaderScroll {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
    }
    init() {
        document.querySelectorAll('[data-header-scroll]').forEach(el => {
            new HeaderScrollItem(el, this)
        })
    }
}

class HeaderScrollItem {
    constructor(element, parent) {
        this.element = element
        this.parent = parent
        this.init()
    }
    init() {
        let lastScrollPosition = 0;
        const offset = 20;

        // default
        this.element.classList.add('navigation--fixed');

        window.addEventListener('scroll', () => {
            const currentScrollPosition = window.pageYOffset;

            if (Math.abs(currentScrollPosition - lastScrollPosition) >= offset) {
                if (currentScrollPosition > lastScrollPosition) {
                    // User is scrolling down
                    this.element.classList.add('navigation--hide');
                } else {
                    // User is scrolling up
                    this.element.classList.remove('navigation--hide');
                }

                lastScrollPosition = currentScrollPosition;
            }

            // if is last then 100px from top
            if (window.scrollY < 200) {
                this.element.classList.add('navigation--fixed');
            } else {
                this.element.classList.remove('navigation--fixed');
            }
        });
    }
}

export default HeaderScroll